module.exports = __webpack_public_path__ + "assets/img/thumb-Nexon-2-Landing-Page.6dced9f3.jpg";